module.exports = __webpack_public_path__ + "assets/img/9123e5afe24c24a46da86d0b22d3031c.svg";